import React, { useState } from "react";
import ModalForm from "../modal";
import SelectForm from "../selectForm";
import { useAuth } from "../authProvider";
import { useTranslation } from "react-i18next";
import DevisService from "../../services/devis.service";
import { showErrorToaster } from "../toasters/error";
import { showSuccessToaster } from "../toasters/success";

function CreateDevis({ fetchUserDevis, setOpen, open }) {
  const { t } = useTranslation();
  const { currentUser } = useAuth();
  console.log("✅ currentUser:", currentUser);
  const userId = currentUser?.userId;
  const [isChecked, setIsChecked] = useState(false);
  const [showCheckError, setShowCheckError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);

  const [data, setData] = useState({
    userId: userId,
    activitySector: currentUser?.activitySector || "",
    servicesDemandes: [],
    budgetEstime: "",
    devise: "",
    description: "",
    dateSoumission: "",
    pieceJointe: null,
    company: currentUser?.company || "",
    KBIS: currentUser?.KBIS || "",
    SIRET: currentUser?.SIRET || "",
    SIREN: currentUser?.SIREN || "",
  });
  const [pdf, setPdf] = useState(null);
  const [errors, setErrors] = useState({});
  const validateForm = () => {
    const newErrors = {};

    if (!data.activitySector)
      newErrors.activitySector = t("Ce champ est requis.");
    if (!data.company) newErrors.company = t("Ce champ est requis.");
    if (!data.servicesDemandes || data.servicesDemandes.length === 0)
      newErrors.servicesDemandes = t("Ce champ est requis.");
    if (!data.budgetEstime) newErrors.budgetEstime = t("Ce champ est requis.");
    if (!data.description) newErrors.description = t("Ce champ est requis.");
    if (!data.dateSoumission)
      newErrors.dateSoumission = t("Ce champ est requis.");


    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  function handleInputChange(value, name) {
    setData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  }

const handleSubmit = async () => {
  if (!isChecked) {
    setShowCheckError(true);
    return;
  }

  if (!validateForm()) {
    return;
  }

  if (isSubmitted) return; // ⛔ éviter double clic
  setIsSubmitted(true); // ✅ blocage du bouton après clic
  setLoading(true);
  setShowCheckError(false);

  try {
    const formData = new FormData();
    formData.append("clientId", data.userId);
    formData.append("activitySector", data.activitySector);
    formData.append("company", data.company);
    formData.append("servicesDemandes", JSON.stringify(data.servicesDemandes));
    formData.append("budgetEstime", data.budgetEstime);
    formData.append("devise", data.devise);
    formData.append("description", data.description);
    formData.append("dateSoumission", new Date().toISOString());
    formData.append("KBIS", data.KBIS);
    formData.append("SIRET", data.SIRET);
    formData.append("SIREN", data.SIREN);

    if (pdf) {
      formData.append("pieceJointe", pdf);
    }

    await DevisService.createDevis(formData, () => {
      fetchUserDevis();
    });

    closeModalFunction();
  } catch (error) {
    console.log("🚀 ~ handleSubmit ~ error:", error);
    setIsSubmitted(false); // 🔁 réactivation du bouton si erreur
  } finally {
    setLoading(false);
  }
};


  const handleFileChange = (e) => {
    setPdf(e.target.files[0]);
  };

  const closeModalFunction = () => {
    setOpen(false);
  };

  return (
    <>
      <ModalForm
        disabled={!isChecked || loading|| isSubmitted}
        onCancelFunction={closeModalFunction}
        onCloseFunction={closeModalFunction}
        submitFunction={handleSubmit}
        cancelText={t("ANNULER")}
        applyTitle={t("ENVOYER")}
        isOpened={open}
        dialogTitle={t("Nouveau devis")}
        dialogContentChild={
          <div className="row mailing-section p-3">
            <div className="col-lg-12">
              <div className="mb-3 mt-4 secteur-title">
                {t("Secteur d’activité")}
              </div>
              <input
                type="text"
                className="form-control"
                name="activitySector"
                value={data.activitySector}
                onChange={(e) =>
                  handleInputChange(e.target.value, e.target.name)
                }
                required
              />
              {errors.activitySector && (
                <div className="text-danger mt-1">{errors.activitySector}</div>
              )}
            </div>
            <div className="row">
              {/* Entreprise + KBIS */}
              <div className="col-lg-6">
                <div className="mb-3 mt-4 secteur-title">{t("Entreprise")}</div>
                <input
                  type="text"
                  className="form-control"
                  name="company"
                  value={data.company}
                  onChange={(e) =>
                    handleInputChange(e.target.value, e.target.name)
                  }
                  required
                />
                {errors.company && (
                  <div className="text-danger mt-1">{errors.company}</div>
                )}
              </div>
              <div className="col-lg-6">
                <div className="mb-3 mt-4 secteur-title">KBIS</div>
                <input
                  type="text"
                  className="form-control"
                  name="KBIS"
                  value={data.KBIS}
                  readOnly
                />
              </div>
            </div>

            <div className="row">
              {/* SIRET + SIREN */}
              <div className="col-lg-6">
                <div className="mb-3 mt-4 secteur-title">SIRET</div>
                <input
                  type="text"
                  className="form-control"
                  name="SIRET"
                  value={data.SIRET}
                  readOnly
                />
              </div>
              <div className="col-lg-6">
                <div className="mb-3 mt-4 secteur-title">SIREN</div>
                <input
                  type="text"
                  className="form-control"
                  name="SIREN"
                  value={data.SIREN}
                  readOnly
                />
              </div>
            </div>

            <div className="col-lg-12">
              <div className="mb-3 mt-4 secteur-title">
                {t("Types de services souhaités")}
              </div>
              <input
                type="text"
                className="form-control"
                name="servicesDemandes"
                value={data.servicesDemandes}
                onChange={(e) =>
                  handleInputChange(e.target.value, e.target.name)
                }
                required
                placeholder={t("Ex: Création de site web")}
              />
              {errors.servicesDemandes && (
                <div className="text-danger mt-1">
                  {errors.servicesDemandes}
                </div>
              )}
            </div>

            <div className="col-lg-5">
              <div className="mb-3 mt-4 secteur-title">
                {t("Budget estimé HT")}
              </div>
              <div className="d-flex gap-3">
                <input
                  type="number"
                  className="budget form-control flex-grow-1"
                  placeholder={t("Enter budget")}
                  name="budgetEstime"
                  required
                  onChange={(e) =>
                    handleInputChange(e.target.value, e.target.name)
                  }
                  value={data.budgetEstime}
                />
                <br />

                <SelectForm
                  options={[{ value: "EUR", name: "EUR" }]}
                  name="devise"
                  onChangeFunction={handleInputChange}
                  value={data.devise}
                />
              </div>
              {errors.budgetEstime && (
                <div className="text-danger mt-1">{errors.budgetEstime}</div>
              )}
            </div>

            <div className="col-lg-12">
              <div className="mb-3 mt-4 secteur-title">
                {t("Description détaillée de votre projet")}
              </div>
              <textarea
                className="form-control"
                name="description"
                rows="4"
                required
                value={data.description}
                placeholder="Ajoutez une description détaillée de votre projet"
                onChange={(e) =>
                  handleInputChange(e.target.value, e.target.name)
                }
              />
              {errors.description && (
                <div className="text-danger mt-1">{errors.description}</div>
              )}
            </div>

            <div className="col-lg-12">
              <div className="mb-3 mt-4 secteur-title">
                {t("Date de création de projet")}
              </div>
              <input
                type="date"
                className="form-control"
                onChange={(e) =>
                  handleInputChange(e.target.value, e.target.name)
                }
                name="dateSoumission"
                value={data.dateSoumission}
                required
              />
              {errors.dateSoumission && (
                <div className="text-danger mt-1">{errors.dateSoumission}</div>
              )}
            </div>

            <div className="col-lg-12">
              <div className="mb-3 mt-4 secteur-title">{t("Pièce jointe")}</div>
              <div className="custom-file-wrapper">
                <input
                  type="file"
                  id="fileUpload"
                  className="custom-file-input"
                  onChange={handleFileChange}
                  accept=".pdf,.jpg,.jpeg,.png,.docx"
                  
                />

                <div className="custom-file-placeholder">
                  {(pdf && pdf.name) ||
                    "(upload de fichiers, formats acceptés : PDF, JPG, PNG, DOCX, etc.)"}
                  <button
                    type="button"
                    className="custom-upload-btn"
                    onClick={() =>
                      document.getElementById("fileUpload").click()
                    }
                  >
                    {t("Joindre")}
                  </button>
                </div>
              </div>
            </div>
           
            {/* ✅ Checkbox de validation */}
            <div className="col-lg-12 mt-4">
              <div className="form-check d-flex align-items-center gap-2">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="validationCheck"
                  checked={isChecked}
                  onChange={() => setIsChecked(!isChecked)}
                />
                <label className="form-check-label" htmlFor="validationCheck">
                  {t("Validation des champs avant soumission")}
                </label>
              </div>
              {showCheckError && (
                <div className="text-danger mt-2">
                  {t("Veuillez cocher la case pour valider.")}
                </div>
              )}
            </div>
          </div>
        }
      />
    </>
  );
}

export default CreateDevis;
